module.exports = __webpack_public_path__ + "static/shipkoo-vat-13713fee77dd91b1567a816cd423d618.png";